export default "__VITE_ASSET__COSz_3mI__"